import { KycType } from 'Models/KycType'
import './InvestorsKyc.scss'
import { Key, useEffect, useState } from 'react'
import ListPagination from 'Components/ListPagination/ListPagination'
import { useListPagination } from 'Hooks/useListPagination'
import kycServices from 'Services/kycServices'
import { HorizontalLoader } from 'Components'
import { TimeConverter } from 'Helpers/TimeConverter'
import { formatString } from 'Helpers/formatString'
import { handleError, handleSuccess } from 'Helpers'
import { Link } from 'react-router-dom'

const InvestorsKyc = () => {
  const { page, setPage, limit, changePageSize } = useListPagination()
  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const [loading, setLoading] = useState(false)

  const [kyc, setKyc] = useState<KycType[]>([])

  const [status, setStatus] = useState('ALL')

  const [sortOrder, setSortOrder] = useState('DESC')

  const getKyc = async () => {
    setLoading(true)
    await kycServices.index(page, sortOrder, status, limit).then(
      (response) => {
        setLoading(false)
        setKyc(response?.data.data.dataset)
        console.log('KYC Card response', response)

        setPaginationData({
          pageNumber: response?.data.data.pageNumber,
          pageSize: response?.data.data.pageSize,
          total: response?.data.data.total,
        })
      },
      (error: { response: object }) => {
        setLoading(false)
      },
    )
  }

  useEffect(() => {
    getKyc()
  }, [page, limit, sortOrder, status])

  const handleApprove = async (kycId: string) => {
    if (!window.confirm('Approve this KYC application?')) return

    setLoading(true)
    await kycServices.approve(kycId).then(
      () => {
        getKyc()
        setLoading(false)
        handleSuccess('Application Approved succesfully')
      },
      (error) => {
        setLoading(false)
        handleError(error)
      },
    )
  }

  const handleReject = async (kycId: string) => {
    const reason = confirm('Are you sure you want to reject this KYC application?')

    if (reason === false) return

    setLoading(true)
    await kycServices.reject(kycId).then(
      () => {
        getKyc()
        setLoading(false)
        handleSuccess('Application rejected succesfully')
      },
      (error) => {
        setLoading(false)
        handleError(error)
      },
    )
  }

  return (
    <div className='InvestorsKyc'>
      <div className='container- mt-4'>
        <div className='card border-0'>
          {/* <div className='card-header border-0'>
            <div className='row'>
              <div className='col-12 col-md-8 my-auto'>
                <div className='title'>Investors KYC Application</div>
              </div>
            </div>
          </div> */}
          <div className='card-body'>
            <div className='table-responsive'>
              <table className='table'>
                <thead>
                  <tr>
                    <td>Company Name</td>
                    <td>Company Name</td>
                    <td>Company Phone</td>
                    <td>TIN</td>
                    <td> Status</td>
                    <td>Date Created</td>
                    <td>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {kyc.length > 0 &&
                    kyc.map((data: KycType, index: Key) => (
                      <tr key={index}>
                        <td>#{data.companyName}</td>
                        <td>{data.companyName}</td>
                        <td>{data.companyPhoneNumber}</td>
                        <td>{data.tinNumber}</td>{' '}
                        <td>
                          <span className='as-status-pending'>{formatString(data.status)}</span>
                        </td>
                        <td>{TimeConverter(data.createdAt)}</td>
                        <td>
                          <Link to={`/investors-kyc/${data.id}`} className='text-decoration-none'>
                            <button className='btn border-0'>View</button>
                          </Link>
                        </td>
                        <td className='dropdown option-dropdown'>
                          <button
                            className='btn border-0 dropdown-toggle'
                            data-bs-toggle='dropdown'
                            aria-expanded='false'
                            data-bs-popper-config='{"strategy":"fixed"}'
                          >
                            <svg
                              width='18'
                              height='18'
                              viewBox='0 0 24 24'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <circle cx='12' cy='5' r='2' fill='currentColor' />
                              <circle cx='12' cy='12' r='2' fill='currentColor' />
                              <circle cx='12' cy='19' r='2' fill='currentColor' />
                            </svg>
                          </button>

                          <ul className='dropdown-menu dropdown-menu-end'>
                            <li>
                              <button
                                className='dropdown-item text-success'
                                onClick={() => handleApprove(data.id)}
                              >
                                Approve
                              </button>
                            </li>
                            <li>
                              <button
                                className='dropdown-item text-danger'
                                onClick={() => handleReject(data.id)}
                              >
                                Reject
                              </button>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    ))}

                  {loading === false && kyc.length === 0 && (
                    <tr>
                      <td colSpan={8} className='text-center'>
                        No KYC application found
                      </td>
                    </tr>
                  )}
                  {loading === true && kyc.length === 0 && (
                    <tr>
                      <td colSpan={8} className='text-center'>
                        <HorizontalLoader></HorizontalLoader>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <ListPagination
                page={page}
                limit={limit}
                total={paginationData.total}
                disabled={loading}
                onPageChange={setPage}
                onPageSizeChange={changePageSize}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InvestorsKyc
